import {useGetInfiniteSpecialists} from '@/features/projects/specialists/queries/useGetInfiniteSpecialists'

interface UseSpecialistsListProps {
    limit?: number
    search?: string
    enabled?: boolean
}

export const useSpecialistsList = ({limit = 10, search, enabled}: UseSpecialistsListProps) => {
    const query = useGetInfiniteSpecialists({
        params: {
            page: 1,
            limit,
            search
        },
        options: {enabled}
    })

    return {
        ...query,
        specialists: query.data?.pages.flatMap(page => page.data) ?? []
    }
}
